import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { endpoints } from '@rossum/api-client';
import { CreateHookPayload } from '@rossum/api-client/hooks';
import { api } from '../../../lib/apiClient';
import { throwError, throwInfo } from '../../../redux/modules/messages/actions';
import { QUERY_KEY_HOOKS } from './useHooks';

export const useCreateHook = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateHookPayload) =>
      api.request(endpoints.hooks.create(payload)),

    onSuccess: () => {
      dispatch(throwInfo('extensionCreated'));
      queryClient.invalidateQueries([QUERY_KEY_HOOKS]);
    },

    onError: () => {
      dispatch(throwError('extensionUpdateFailed'));
    },
  });
};
